import React, { useContext } from 'react'
import { publishX } from '../beebotte/publish'
import logo from '../assets/logo.svg'
import { MainContext } from '../MainContext'
import { useHistory } from 'react-router-dom'

const SelectMode = () => {
  const history = useHistory()
  const { setMode, setNeedToTrackFace, setLoading } = useContext(MainContext)
  const send = () => {
    publishX(99)
  }

  const handleJump = (needToTrackFace: boolean) => {
    setNeedToTrackFace(needToTrackFace)
    setMode('meet')
    setLoading(true)
    if (needToTrackFace) {
      history.push('/meet?trackface=true')
    } else {
      history.push('/meet?trackface=false')
    }
  }

  return (
    <div className="container">
      <div className="clouds"></div>

      <img src={logo} alt="" className="logo" />

      <div className="btnContainer">
        <button className="btn see" onClick={() => handleJump(true)} />
        <button className="btn" onClick={send}>
          送る
        </button>
      </div>
      <small>(c)2020 phat-thai.</small>
    </div>
  )
}

export default SelectMode
